module.exports = __webpack_public_path__ + "img/41431bdd2f958caabe2be5ce3dd8d62b.jpg";